module.exports = __webpack_public_path__ + "img/pinfl__uz__id_doc.73a34cbe.png";